import { useContext, useEffect, useState } from "react";

// react-router components
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

// Global styles
import "./styles/global.css";

// Material Dashboard 2 React components

// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";

// Material Dashboard 2 React themes
import theme from "assets/theme";

// Material Dashboard 2 React routes
import routes from "routes";

// Material Dashboard 2 React contexts
import {
	setMiniSidenav,
	setOpenConfigurator,
	useMaterialUIController,
} from "context";

// Images
import brandWhite from "../src/pages/logo_bottoli.png";

import ForgotPassword from "auth/forgot-password";
import Login from "auth/login";
import Register from "auth/register";
import ResetPassword from "auth/reset-password";
import { AuthContext } from "context";
import ProtectedRoute from "examples/ProtectedRoute";
import { setupAxiosInterceptors } from "./services/interceptor";

import toast, { Toaster, ToastBar } from "react-hot-toast";
import { Provider } from "react-redux";
import AreaSelection from "./pages/areaSelection/areaSelection";
import LoginRegister from "./pages/supplierArea/loginRegistrer.tsx";
import store from "./store";

export default function App() {
	const authContext = useContext(AuthContext);

	const [controller, dispatch] = useMaterialUIController();
	const { miniSidenav, direction, layout, sidenavColor } = controller;
	const [onMouseEnter, setOnMouseEnter] = useState(false);
	const [areaSelected, setAreaSelected] = useState(null);
	const { pathname } = useLocation();

	// Open sidenav when mouse enter on mini sidenav
	const handleOnMouseEnter = () => {
		if (miniSidenav && !onMouseEnter) {
			setMiniSidenav(dispatch, false);
			setOnMouseEnter(true);
		}
	};

	// Close sidenav when mouse leave mini sidenav
	const handleOnMouseLeave = () => {
		if (onMouseEnter) {
			setMiniSidenav(dispatch, true);
			setOnMouseEnter(false);
		}
	};

	// if the token expired or other errors it logs out and goes to the login page
	const navigate = useNavigate();
	setupAxiosInterceptors(() => {
		navigate("/auth/login");
	});

	// Setting the dir attribute for the body element
	useEffect(() => {
		document.body.setAttribute("dir", direction);
	}, [direction]);

	// Setting page scroll to 0 when changing the route
	useEffect(() => {
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
	}, [pathname]);

	const getRoutes = (allRoutes) =>
		allRoutes.map((route) => {
			if (route.collapse) {
				return getRoutes(route.collapse);
			}

			if (route.route && route.type !== "auth") {
				return (
					<Route
						exact
						path={route.route}
						element={
							<ProtectedRoute
								isAuthenticated={authContext?.isAuthenticated}
							>
								{route.component}
							</ProtectedRoute>
						}
						key={route.key}
					/>
				);
			}
			return null;
		});

	return (
		<>
			<Provider store={store}>
				<ThemeProvider theme={theme}>
					<CssBaseline />
					<div
						className={
							pathname.startsWith("/auth/") ? "" : "app-container"
						}
					>
						{layout === "dashboard" &&
						authContext?.hasAuth("VIEW_SIDEBAR") ? (
							<Sidenav
								color={sidenavColor}
								brand={brandWhite}
								brandName="EDILMATE"
								routes={routes}
							/>
						) : null}
						<Routes>
							<Route path="/auth/login" element={<Login />} />
							<Route
								path="/selected-area"
								element={
									<AreaSelection
										areaSelected={areaSelected}
										setAreaSelected={setAreaSelected}
									/>
								}
							/>
							<Route
								path="/auth/register"
								element={<Register />}
							/>
							<Route
								path="/auth/forgot-password"
								element={<ForgotPassword />}
							/>
							<Route
								path="/auth/reset-password"
								element={<ResetPassword />}
							/>
							<Route
								path="/login-register-supplier"
								element={<LoginRegister />}
							/>
							{getRoutes(routes)}
						</Routes>
					</div>
				</ThemeProvider>
				<Toaster
					position="top-right"
					toastOptions={{
						duration: 3000,
						error: { duration: 4000 },
					}}
				>
					{(t) => (
						<ToastBar toast={t}>
							{({ icon, message }) => (
								<>
									{t.type !== "loading" && (
										<div
											style={{
												cursor: "pointer",
												position: "absolute",
												bottom: 10,
												right: 10,
												fontSize: "0.7rem",
											}}
											onClick={() => toast.dismiss()}
										>
											Chiudi
										</div>
									)}
									<div
										style={{
											padding: "10px",
											display: "flex",
											alignItems: "center",
											gap: "10px",
										}}
									>
										{icon}
										{message}
									</div>
								</>
							)}
						</ToastBar>
					)}
				</Toaster>
			</Provider>
		</>
	);
}
